import { WaybillIdView } from '../../../../models';

export class ShipmentWaybillEquipmentsLoad {
  constructor(public payload: WaybillIdView) {}
  public static readonly type = '[ShipmentWaybillEquipments] Equipments Load';
}

export class ShipmentWaybillEquipmentsInitialState {
  public static readonly type = '[ShipmentWaybillEquipments] Set Initial State';
}
